export default (string, prefix = '') =>
  prefix + string[0].toUpperCase() + string.slice(1)
